import { Res, Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Message } from 'core/ui-next/modal';
import { Command } from 'pos/common';
import * as SalesStore from 'pos/modules/main/SalesStore';

declare global {
	interface CommandType {
		removeLoyaltyInfo: () => Promise<Result>
	}
}

Command.register('removeLoyaltyInfo', Preconditions.and(Preconditions.ensure(Permission.Ticket_RemoveLoyaltyInfo), Preconditions.ensureIsNotLite), async (): Promise<Result> => {

	const { ok } = await Message.confirm(Res.Msg.MSG_CONFIRM_REMOVE_LOYALTY_INFO());

	if (ok) {
		await SalesStore.removeLoyaltyInfo();
	}

	return Result.ok();
});